import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchLoggedInUserOrders,
  updateUser,
  fetchLoggedInUser,
  removeLoggedInUser,
  fetchAllUsers,
  updateUserByAdmin,
  deleteUser,
} from "./userAPI";

const initialState = {
  status: "idle",
  userInfo: null,
  allUsers: null,
  totalUsers: null,
};

export const fetchLoggedInUserOrderAsync = createAsyncThunk(
  "user/fetchLoggedInUserOrders",
  async () => {
    const response = await fetchLoggedInUserOrders();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const fetchLoggedInUserAsync = createAsyncThunk(
  "user/fetchLoggedInUser",
  async () => {
    const response = await fetchLoggedInUser();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const updateUserAsync = createAsyncThunk(
  "user/updateUser",
  async (update) => {
    // this is name mistake
    const response = await updateUser(update);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const updateUserByAdminAsync = createAsyncThunk(
  "user/updateUserByAdmin",
  async (update) => {
    // this is name mistake
    const response = await updateUserByAdmin(update);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const deleteUserAsync = createAsyncThunk(
  "user/deleteUser",
  async (id) => {
    const response = await deleteUser(id);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const removeLoggedInUserAsync = createAsyncThunk(
  "user/removeLoggedInUser",
  async () => {
    // this is name mistake
    const response = await removeLoggedInUser();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const fetchAllUsersAsync = createAsyncThunk(
  "user/fetchAllUsers",
  async ({ sort, pagination }) => {
    const response = await fetchAllUsers(sort, pagination);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoggedInUserOrderAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLoggedInUserOrderAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.userInfo.orders = action.payload;
      })
      .addCase(updateUserAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateUserAsync.fulfilled, (state, action) => {
        state.status = "idle";
        // earlier there was loggedInUser variable in other slice
        state.userInfo = action.payload;
      })
      .addCase(fetchLoggedInUserAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLoggedInUserAsync.fulfilled, (state, action) => {
        state.status = "idle";
        // this info can be different or more from logged-in User info
        state.userInfo = action.payload;
      })
      .addCase(removeLoggedInUserAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(removeLoggedInUserAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.userInfo = null;
      })
      .addCase(fetchAllUsersAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllUsersAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.allUsers = action.payload.users;
        state.totalUsers = action.payload.totalUsers;
      })
      .addCase(deleteUserAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteUserAsync.fulfilled, (state, action) => {
        state.status = "idle";
        // Assuming action.payload contains the ID of the deleted user
        const deletedUserId = action.payload;
        console.log(deletedUserId);

        // Filter out the deleted user from state.allUsers array
        const updatedAllUsers = state.allUsers.filter(
          (user) => user.id !== deletedUserId
        );
        state.allUsers = updatedAllUsers;
        state.totalUsers = state.totalUsers - 1;
      })
      .addCase(updateUserByAdminAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateUserByAdminAsync.fulfilled, (state, action) => {
        state.status = "idle";
        // Assuming action.payload contains the updated user object
        const updatedUser = action.payload;

        // Updating state.allUsers array
        const updatedAllUsers = state.allUsers.map((user) => {
          // Check if the current user's id matches the id of the updated user
          if (user.id === updatedUser.id) {
            // Replace the current user with the updated user
            return updatedUser;
          } else {
            // Otherwise, return the current user unchanged
            return user;
          }
        });

        state.allUsers = updatedAllUsers;
      });
  },
});

// TODO: change orders and address to be independent of user;
export const selectUserOrders = (state) => {
  if (state.user.userInfo && state.user.userInfo.orders) {
    return state.user.userInfo.orders;
  } else {
    return []; // or any other default value you prefer
  }
};

export const selectUserInfo = (state) => state.user.userInfo;
export const selectUsers = (state) => state.user.allUsers;
export const selectTotalUsers = (state) => state.user.totalUsers;

// export const { increment } = userSlice.actions;

export default userSlice.reducer;
